<template>
    <div id="cartaoform" class="checkout">
        <ConfirmDialog></ConfirmDialog>
        <Toast position="center"/>
        <Dialog :visible.sync="showCopiarCartao">
            <template #header>
                <h3>Cartões para homologar no PJBank</h3>
            </template>
            <br>4012 0010 3714 1112 validade: 05/2027 ccv: 123 &nbsp; <i class='far fa-copy' @click='cpcartao("4012001037141112")'></i>
            <br>5453 0100 0006 6167 validade: 05/2027 ccv: 123 &nbsp; <i class='far fa-copy' @click='cpcartao("5453010000066167")'></i>
            <br>4012 0010 3844 3335 validade: 05/2027 ccv: 123 &nbsp; <i class='far fa-copy' @click='cpcartao("4012001038443335")'></i>
            <br>5453 0100 0006 6167 validade: 05/2027 ccv: 123 &nbsp; <i class='far fa-copy' @click='cpcartao("5453010000066167")'></i>
            <br>3764 4904 7333 0005 validade: 05/2027 ccv: 123 &nbsp; <i class='far fa-copy' @click='cpcartao("3764490473330005")'></i>
            <br>6362 9700 0045 7013 validade: 05/2027 ccv: 123 &nbsp; <i class='far fa-copy' @click='cpcartao("6362970000457013")'></i>
            <br>6011 0200 0024 5045 validade: 05/2027 ccv: 123 &nbsp; <i class='far fa-copy' @click='cpcartao("6011020000245045")'></i>
            <br>3566 0077 7000 4971 validade: 05/2027 ccv: 123 &nbsp; <i class='far fa-copy' @click='cpcartao("3566007770004971")'></i>
            <br><br>Qualquer divergência de validade dos cartões acima deve ser repassado para PJBANK.
            <br>Para testar um erro na transação envie um valor entre 7.00 e 8.00,<br>
                todos os outros resultam em um transação aprovada.

            <template #footer>
                <button id="btn-confirmar-alerta" class="p-button-text btn btn-primary btn-confirm" @click="fecharCopiarCartao()">
                    <i class="fa fa-ban fa-lg"></i> Fechar
                </button>
            </template>
        </Dialog>

        <div class="credit-card-box">
            <div class="flip">
                <div class="front">
                    <div class="chip"></div>
                    <div class="logo">
                    </div>
                    <div class="number"></div>
                    <div class="card-holder">
                        <label>NOME NO CARTÃO</label>
                        <div></div>
                    </div>
                    <div class="card-expiration-date">
                        <label>VALIDADE</label>
                        <div></div>
                    </div>
                </div>
                <div class="back">
                    <div class="strip"></div>
                    <div class="logo">
                    </div>
                    <div class="ccv">
                        <label>CCV</label>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>

        <div id="modal_loading" class="modal fade">
            <div class="modal-dialog">
                <div class="modal-content" style="width:50px; height: 100%; margin-left: 70px">
                    <div class="checkout-message">
                        <div id="checkout-center" class="checkout-center">
                            <img class="image-center" src="images/loading3.gif" height="150px"  alt="Carregando"/>
                        </div>
                        <div style="text-align: center; width: 100%; height: 100%">
                            <h3>Carregando.... Aguarde.</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="modal_alerta" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content" style="width: 80%; margin-left: 10%">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">
                            <span aria-hidden="true">&times;</span>
                            <span class="sr-only">Fechar</span>
                        </button>
                        <h4 class="modal-title">&nbsp;</h4>
                    </div>

                    <div class="modal-body"></div>

                    <div class="modal-footer">
                        <button id='btn-confirmar-alerta' class="btn btn-primary btn-confirm" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <form id="formcartao" class="form" autocomplete="off" novalidate method="post" :action="cartao_url" >
            <input type="hidden" id="tra_identificador" name="tra_identificador" v-model="tra_identificador" />
            <input type="hidden" id="tra_credencial" name="tra_credencial" v-model="tra_credencial" />
            <input type="hidden" id="tra_uuid" name="tra_uuid" v-model="tra_uuid" />
            <input type="hidden" id="token_conta" name="token_conta" v-model="token_conta" />
            <input type="hidden" id="homologacao" name="homologacao" v-model="homologacao" />
            <input type="hidden" id="token_cliente" name="token_cliente" v-model="token_cliente" />
            <input type="hidden" name="cartao" id="cartao" class="pjbank-cartao" required  />
            <input type="hidden" name="pjbank-token" id="pjbank-token" class="pjbank-token">

            <fieldset v-if="homologacao">
                <label for="card-number">Você está em um ambiente de homologação. <a href="#" v-on:click.prevent="showAlertaCartao()">Somente estes cartões serão aceitos.</a></label>
            </fieldset>

            <fieldset class="m-tn-20">
                <label for="card-number">Bandeiras aceitas</label>
                <img class="cartao-bandeiras" src="images/cartao/mastercard.png" alt="Mastercard">
                <img class="cartao-bandeiras" src="images/cartao/visa.png" alt="Visa">
                <img class="cartao-bandeiras" src="images/cartao/elo.png" alt="ELO">
            </fieldset>
            <fieldset>
                <label for="card-number">Número do cartão</label>
                <input type="text" id="card-number"  name="card_number"  v-model="card_number" class="input-cart-number" maxlength="4" />
                <input type="text" id="card-number2" name="card_number1" v-model="card_number1" class="input-cart-number" maxlength="4" />
                <input type="text" id="card-number3" name="card_number2" v-model="card_number2" class="input-cart-number" maxlength="4" />
                <input type="text" id="card-number4" name="card_number3" v-model="card_number3" class="input-cart-number" maxlength="4" />
            </fieldset>

            <fieldset>
                <label for="card-holder">Nome do Titular</label>
                <input type="text" id="card-holder" name="card_holder" v-model="cardholder" />
            </fieldset>
            <fieldset>
                <label for="card-cpf">CPF/CNPJ do Titular</label>
                <input type="text" id="card-cpf" name="card_cpf" v-model="card_cpf" />
            </fieldset>
            <fieldset class="fieldset-expiration">
                <label for="card-expiration-month">Validade</label>
                <div class="select">
                    <select class="form-control select2" id="card-expiration-month" name="card_expiration_month" data-placeholder="Validade" v-model="cardexpirationmonth">
                        <option v-for="lista in listmonthvalidate" :key="lista" :value="lista">
                            {{ lista }}
                        </option>
                    </select>
                </div>

                <div class="select">
                    <select class="form-control select2" id="card-expiration-year" name="card_expiration_year" data-placeholder="Validade" v-model="cardexpirationyear">
                        <option v-for="lista in listyearvalidate" :key="lista" :value="lista">
                            {{ lista }}
                        </option>
                    </select>
                </div>
            </fieldset>
            <fieldset class="fieldset-ccv">
                <label for="card-ccv">CCV</label>
                <input type="text" id="card-ccv" name="card_ccv" v-model="card_ccv" class="" maxlength="3" />
            </fieldset>
            <fieldset class="fieldset-expiration">
                <label>Valor</label>
                <label style="font-size:27px;">{{ tra_valor }}</label>
            </fieldset>

            <fieldset class="fieldset-ccv" v-if="listplots.length > 1">
                <label>Parcelas</label>
                <div class="select">
                    <select class="field-ccv" id="plots" name="plots" data-placeholder="Parcelas">
                        <option v-for="lista in listplots" :key="lista" :value="lista">
                            {{ lista }}
                        </option>
                    </select>
                </div>
            </fieldset>

            <fieldset>
                <label for="card-holder">Telefone do Titular</label>
                <input type="text" id="phone" name="phone" v-model="phone" class="" maxlength="15" />
            </fieldset>
            <fieldset>
                <label for="card-holder">E-mail do Titular</label>
                <input type="text" id="email" name="email" v-model="email" class="" maxlength="200" />
            </fieldset>

            <fieldset>
                <label for="card-holder">Descrição</label>
                <label style="font-size:16px;">{{ description }}</label>
            </fieldset>
            <button type="button" @click="submitFormAndHeader();" class="btn"><i class="fa fa-lock"></i> Enviar</button>
        </form>
    </div>
</template>

<script>
import LoadingBar from "./loadingbar.component";
import axios from 'axios';
import Toast from 'primevue/toast';
import Tooltip from 'primevue/tooltip';
import ConfirmDialog from 'primevue/confirmdialog';
import Dialog from 'primevue/dialog';
import $ from 'jquery';
import * as external from "../vue/external";
import * as flagcards from "../vue/flagcards";
import * as bootbox from "bootbox";
import {trim} from "lodash";
import {validaCPF, validaCNPJ} from "../assets/js/utils";

export default {
    name: 'cartaoform',
    props: [
        'versao',
        'ambiente',
        'homologacao',
                        'tra_identificador',
        'tra_credencial',
        'tra_uuid',
        'tra_valor',
        'num_max_parcelas',
        'description',
        'token_conta',
            'token_cliente',
        'mobileform',
        'base_url',
        'cartao_url',
        'parcelas',
        'meses',
        'anos'
    ],
    directives: {
        'tooltip': Tooltip,
    },
    components: {
        LoadingBar, ConfirmDialog, Toast, Dialog
    },
    data() {
        return {
            urlContexto: '',
            password: null,
            show: false,
            mensagemUsuario: [],
            modeloform: 1,
            processando: false,
            listmonthvalidate: [],
            listyearvalidate: [],
            listplots: [],
            showCopiarCartao: false,
            card_number: '',
            card_number1: '',
            card_number2: '',
            card_number3: '',
            cardholder: '',
            card_cpf: '',
            phone: '',
            email: '',
            cardexpirationmonth: '',
            cardexpirationyear: '',
            card_ccv: '',

        }
    },
    computed: {},
    mounted() {
        const vm = this;

        $("#card-cpf").mask('00000000000000');
        $("#phone").mask('(00) 00000-0000');

        $("#card-number").mask('0000');
        $("#card-number1").mask('0000');
        $("#card-number2").mask('0000');
        $("#card-number3").mask('0000');
        $("#ccv").mask('000');

        this.listmonthvalidate = JSON.parse(this.meses);
        this.listyearvalidate = JSON.parse(this.anos);
        this.listplots = JSON.parse(this.parcelas);
        // console.log(this.listmonthvalidate);

        // external.body_script('https://s3-sa-east-1.amazonaws.com/widgets.superlogica.net/embed.js');
        // // scripts da PJBANK
        // superlogica.require("pjbank");
        // superlogica.pjbank("checkout_transparente", vm.tra_credencial, vm.homologacao );
        // console.log("PJBank inicializado...");
        // // scripts da PJBANK - FIM

        // external.body_script('assets/js/captarcartao.js?v=');

        $('.input-cart-number').on('keyup change', function () {
            let t = $(this);

            if (t.val().length > 3) {
                // console.log('Próximo focus: OP1 ---> ');
                // console.log(t);
                t.next().focus();
                // return ;
            }

            let card_number = '';
            let completo = true;
            $('.input-cart-number').each(function (index) {
                let bloco = $(this).val();
                // console.dir(index);
                // console.log("Bloco ---> " + bloco);

                card_number += bloco + ' ';
                // console.log("length: " + bloco.length);
                if (completo && bloco.length === 4) {
                    // console.log('Próximo focus: OP2 ---> ' + index);
                    // console.dir($(this));
                    // $(this).next().focus();
                    // $(this).next().css( "background-color", "red" );
                } else {
                    completo = false;
                }
            });

            $('.credit-card-box .number').html(card_number);
            // console.log('card_number', card_number);
            // console.log(flagcards.getCardFlag(card_number));

        });

        $('#card-holder').on('keyup change', function () {
            t = $(this);
            $('.credit-card-box .card-holder div').html(t.val());
        });

        $('#card-holder').on('keyup change', function () {
            t = $(this);
            $('.credit-card-box .card-holder div').html(t.val());
        });

        $('#card-expiration-month, #card-expiration-year').change(function () {
            m = $('#card-expiration-month option').index($('#card-expiration-month option:selected'));
            m = m + 1;
            m = (m < 10) ? '0' + m : m;
            expiracao = $('#card-expiration-year').val();
            // console.log('expiracao', expiracao);
            y = expiracao.substr(2, 2);
            $('.card-expiration-date div').html(m + '/' + y);
        })

        $('#card-ccv').on('focus', function () {
            $('.credit-card-box').addClass('hover');
            // console.log('hover do CCV');
        }).on('blur', function () {
            $('.credit-card-box').removeClass('hover');
        }).on('keyup change', function () {
            $('.ccv div').html($(this).val());
        });

        $('.input-cart-number').on('blur', function () {
            let card_number = $('.credit-card-box .number').html();
            console.log('blur: card_number => ' + card_number);
            // console.log('blur: card_number.length => ' + card_number.length);
            // considerar os espaços da contagem dos blocos
            if (card_number !== undefined && card_number.length > 19 ) {
                console.log(flagcards.getCardFlag(card_number));
            }
        });
    },
    destroyed(){
        // external.del_script('https://s3-sa-east-1.amazonaws.com/widgets.superlogica.net/embed.js');
    },
    updated: function () {
        this.$nextTick(function () {
            if (this.modeloform === 2) {

            }
        });
    },
    methods: {
        clearMensagem() {
            this.mensagemUsuario = [];
        },
        toggle() {
            this.show = !this.show
        },
        fecharCopiarCartao() {
            this.showCopiarCartao = false;
        },
        cpcartao(number_card) {
            let inbl   = 0;
            let inicio = 0;
            let vm     = this;
            while (inbl < 4) {
                let inicio = inbl * 4;
                let fim = inicio + 4;
                let parte = number_card.substring(inicio, fim);
                switch (inbl) {
                    case 0:
                        vm.card_number = parte;
                        break;
                    case 1:
                        vm.card_number1 = parte;
                        break;
                    case 2:
                        vm.card_number2 = parte;
                        break;
                    case 3:
                        vm.card_number3 = parte;
                        break;
                }
                inbl += 1;
            };
            vm.cardexpirationmonth = ('05');
            vm.cardexpirationyear = ('2027');
            vm.card_ccv = ('123');
            vm.showCopiarCartao = false;
        },
        showAlertaCartao() {
            this.showCopiarCartao = true;
        },
        validarEntrada() {
            var card_number = '';
            $('.input-cart-number').each(function () {
                var bloco = $(this).val();
                card_number += bloco + ' ';
            });
            var nome = $('#card-holder').val();
            var mes = $('#card-expiration-month').val();
            var ano = $('#card-expiration-year').val();
            var ccv = $('#card-ccv').val();
            var cpf = $('#card-cpf').val();
            var phone = $('#phone').val();
            var email = $('#email').val();

            var msg = "";
            if (card_number === "" || card_number.length < 16) {
                msg += "Cartão";
            }

            if (nome === "" || nome.length < 3) {
                msg += (msg !== "" ? ", " : " ") + "Nome do Titular";
            }

            if (ccv === "") {
                msg += (msg !== "" ? ", " : " ") + "CCV";
            }

            if (cpf === "" || cpf.length < 11) {
                msg += (msg !== "" ? ", " : " ") + "CPF/CNPJ do Titular";
            }

            if (phone === "" || phone.length < 10) {
                msg += (msg !== "" ? ", " : " ") + "Telefone";
            }

            if (email === "" || email.length < 3) {
                msg += (msg !== "" ? ", " : " ") + "Email";
            }

            valido = true;
            // validando cpf ou cnpj
            if (cpf.length === 11) {
                valido = ValidarCPF(cpf);
            } else if (cpf.length === 14) {
                valido = ValidarCNPJ(cpf);
            }

            if (!valido) {
                SDSNFSeWeb.alertar("CPF/CNPJ do titular inválido.");
                return false;
            }

            if (card_number !== "") {
                bandeira = tgdeveloper.getCardFlag(card_number);
                if (bandeira) {
                    if (bandeira !== 'visa' && bandeira !== 'mastercard' && bandeira !== 'elo') {
                        SDSNFSeWeb.alertar("Bandeiras de cartão aceitas são Visa, Mastercard ou Elo.");
                        return false;
                    }
                } else if (!bandeira) {
                    SDSNFSeWeb.alertar("Bandeira do cartão inválida.");
                    return false;
                }
            }

            if (msg !== "") {
                SDSNFSeWeb.alertar("As informações são obrigatórias. <br>Campos: " + msg);
                return false;
            } else {
                // coloco no numero do cartão os campos concatenados
                // $('#cartao').val(card_number.replaceAll(' ',''));
                // console.log('preparando para gerar token com a PJBank');
                // console.log($('#cartao').val());
                // console.log($('#pjbank-token').val());
                SDSNFSeWeb.exibirLoading();

                return true;
            }

            // $('#signup').on("submit", function(event) {
            //     $form = $(this); //wrap this in jQuery
            //
            //     alert('the action is: ' + $form.attr('action'));
            // });
        },
        submitFormAndHeader() {
            if (this.card_cpf === '') {
                this.$toast.add({severity: 'info', summary: 'Confirmação', detail: 'Necessário informar CPF', life: 3000});
            }
        }
    }
}
</script>

<style scoped>
.cartao-bandeiras {
    width: 70px;
    height: 50px;
}
*,
*::before,
*::after {
    box-sizing: border-box;
}

html,
body {
    min-height: 100%;
    font-family: 'Open sans', sans-serif;
}

body {
    background: #f1efee;
    /* linear-gradient(50deg, #f3c680, #a1e3e2); */
}

/*--------------------
Buttons
--------------------*/
.btn {
    display: block;
    background: #007bff;
    color: white;
    text-decoration: none;
    margin: 20px 0;
    padding: 15px 15px;
    border-radius: 5px;
    position: relative;
}
.btn::after {
    content: '';
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
    box-shadow: inset 0 3px 0 rgba(0, 0, 0, 0), 0 3px 3px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
}
.btn:hover::after {
    background: rgba(0, 0, 0, 0.1);
    box-shadow: inset 0 3px 0 rgba(0, 0, 0, 0.2);
}

/*--------------------
Form
--------------------*/
.form fieldset {
    border: none;
    padding: 10px 0;
    position: relative;
    clear: both;
}
.form fieldset.fieldset-expiration {
    float: left;
    width: 60%;
}
.form fieldset.fieldset-expiration .select {
    width: 84px;
    margin-right: 12px;
    float: left;
}
.form fieldset.fieldset-ccv {
    clear: none;
    float: right;
    width: 86px;
}
.form fieldset label {
    display: block;
    text-transform: uppercase;
    font-size: 11px;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 5px;
    font-weight: bold;
    font-family: Inconsolata;
}
.form fieldset input,
.form fieldset .select {
    width: 100%;
    height: 38px;
    color: #333333;
    padding: 10px;
    border-radius: 5px;
    font-size: 15px;
    outline: none !important;
    border: 1px solid rgba(0, 0, 0, 0.3);
    box-shadow: inset 0 1px 4px rgba(0, 0, 0, 0.2);
}
.form fieldset input.input-cart-number,
.form fieldset .select.input-cart-number {
    width: 82px;
    display: inline-block;
    margin-right: 8px;
}
.form fieldset input.input-cart-number:last-child,
.form fieldset .select.input-cart-number:last-child {
    margin-right: 0;
}
.form fieldset .select {
    position: relative;
}
.form fieldset .select::after {
    content: '';
    border-top: 8px solid #222;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    position: absolute;
    z-index: 2;
    top: 14px;
    right: 10px;
    pointer-events: none;
}
.form fieldset .select select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    position: absolute;
    padding: 0;
    border: none;
    width: 100%;
    outline: none !important;
    top: 6px;
    left: 6px;
    background: none;
    box-shadow: none;
}
.form fieldset .select select :-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
}
.form button {
    width: 100%;
    outline: none !important;
    background: -webkit-gradient(linear, left top, left bottom, from(#49a09b), to(#3d8291));
    background: linear-gradient(180deg, #49a09b, #3d8291);
    text-transform: uppercase;
    font-weight: bold;
    border: none;
    box-shadow: none;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.form button .fa {
    margin-right: 6px;
}

/*--------------------
Checkout
--------------------*/
.checkout {
    margin: 150px auto 30px;
    position: relative;
    width: 460px;
    background: white;
    border-radius: 15px;
    padding: 160px 45px 30px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.image-center {
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.checkout-message {
    margin: 50px auto 30px;
    position: relative;
    width: 460px;
    background: white;
    border-radius: 15px;
    padding: 50px 45px 30px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

/*--------------------
Credit Card
--------------------*/
.credit-card-box {
    -webkit-perspective: 1000px;
    perspective: 1000px;
    width: 400px;
    height: 280px;
    position: absolute;
    top: -112px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
}
.credit-card-box:hover .flip, .credit-card-box.hover .flip {
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
}

@media screen and (max-width: 768px) {

}

.credit-card-box .front,
.credit-card-box .back {
    width: 400px;
    height: 250px;
    border-radius: 15px;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    background: linear-gradient(135deg, #bd6772, #53223f);
    position: absolute;
    color: #fff;
    font-family: Inconsolata;
    top: 0;
    left: 0;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
}

.credit-card-box .front::before,
.credit-card-box .back::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    /*background: url("https://app.sobdemanda.net/images/44386.svg") no-repeat center;*/
    background-size: cover;
    opacity: .05;
}
.credit-card-box .flip {
    -webkit-transition: 0.6s;
    transition: 0.6s;
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
    position: relative;
}
.credit-card-box .logo {
    position: absolute;
    top: 9px;
    right: 20px;
    width: 60px;
}
.credit-card-box .logo svg {
    width: 100%;
    height: auto;
    fill: #fff;
}
.credit-card-box .front {
    z-index: 2;
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
}
.credit-card-box .back {
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
}
.credit-card-box .back .logo {
    top: 185px;
}
.credit-card-box .chip {
    position: absolute;
    width: 60px;
    height: 45px;
    top: 20px;
    left: 20px;
    background: linear-gradient(135deg, #ddccf0 0%, #d1e9f5 44%, #f8ece7 100%);
    border-radius: 8px;
}
.credit-card-box .chip::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    border: 4px solid rgba(128, 128, 128, 0.1);
    width: 80%;
    height: 70%;
    border-radius: 5px;
}
.credit-card-box .strip {
    background: linear-gradient(135deg, #404040, #1a1a1a);
    position: absolute;
    width: 100%;
    height: 50px;
    top: 30px;
    left: 0;
}
.credit-card-box .number {
    position: absolute;
    margin: 0 auto;
    top: 103px;
    left: 19px;
    font-size: 38px;
}
.credit-card-box label {
    font-size: 10px;
    letter-spacing: 1px;
    text-shadow: none;
    text-transform: uppercase;
    font-weight: normal;
    opacity: 0.5;
    display: block;
    margin-bottom: 3px;
}
.credit-card-box .card-holder,
.credit-card-box .card-expiration-date {
    position: absolute;
    margin: 0 auto;
    top: 180px;
    left: 19px;
    font-size: 22px;
    text-transform: capitalize;
}
.credit-card-box .card-expiration-date {
    text-align: right;
    left: auto;
    right: 20px;
}
.credit-card-box .ccv {
    height: 36px;
    background: #fff;
    width: 91%;
    border-radius: 5px;
    top: 110px;
    left: 0;
    right: 0;
    position: absolute;
    margin: 0 auto;
    color: #000;
    text-align: right;
    padding: 10px;
}
.credit-card-box .ccv label {
    margin: -25px 0 14px;
    color: #fff;
}

.the-most {
    position: fixed;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 50vw;
    max-width: 200px;
    padding: 10px;
}
.the-most img {
    max-width: 100%;
}

.credit-card-box .front-message,
.credit-card-box .back-message {
    width: 400px;
    /*height: 250px;*/
    border-radius: 15px;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    background: linear-gradient(135deg, #bd6772, #53223f);
    position: absolute;
    color: #fff;
    font-family: Inconsolata;
    top: 0;
    left: 0;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
}

.credit-card-box .front-message::before,
.credit-card-box .back-message::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-size: cover;
    opacity: .05;
}
</style>
